import { VerticalAlignment } from '../enums/verticalAlignment'

export default class GridDefinition {
  static getVerticalAlignmentClass(verticalAlignment: VerticalAlignment): string {
    switch (verticalAlignment) {
      case VerticalAlignment.Top:
        return 'f-align-items-top';
      case VerticalAlignment.Center:
        return 'f-align-items-center';
      case VerticalAlignment.Bottom:
        return 'f-align-items-bottom';
      default:
        return ''
    }
  }
}
